import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import UserRoleActions from '../../actions/UserRoleActions';
import UserRoleStore from '../../stores/UserRoleStore';
import { Modal, Input, Slider, Button, message } from 'antd';
import ReactQiniuModule from '../../../../lib/ReactQiniuModule';
import AddTeacherModal from '../share/AddTeacherModal';
import { Link } from 'react-router'
const Search = Input.Search;

export default class SchoolAdminClassManagePage extends React.Component {
static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      students: [],
      removedStudents: [],
      teachers: [],
      currentRole: CurrentRoleStore.getCurrentRole(),
      modal: {
        visible: false,
        title: null,
        type: '',
        confirm: null,
        content: null,
      },
      changeClassModal: {
        visible: false,
        title: null,
        type: '',
        confirm: null,
        content: null,
      },
      editInfo: {
        full_name: '',
        avatar_url: '',
      },
      classId: props.params.classId,
      schoolId: props.params.schoolId,
      classInfo: null,
      classAdmin: 0,
      selectAdmin: 0,
      searchTeacherResult: [],
      uploading: false,
      getImgInfo: false,
      showAddTeacherModal: false,

      //
      grades: []
    };
    // bind this
    this._containerTitle = this._containerTitle.bind(this);
    this._studentDetail = this._studentDetail.bind(this);
    this._teacherDetail = this._teacherDetail.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this._editStudent = this._editStudent.bind(this);
    this.editStudent = this.editStudent.bind(this);
    this.removeStudent = this.removeStudent.bind(this);
    this.adjustStudent = this.adjustStudent.bind(this);
    this.editStudentApi = this.editStudentApi.bind(this);
    this.selectClassAdmin = this.selectClassAdmin.bind(this);
    this.setClassAdmin = this.setClassAdmin.bind(this);
    this.removeTeacher = this.removeTeacher.bind(this);
    this.addTeacher = this.addTeacher.bind(this);
    this.editAvatar = this.editAvatar.bind(this);
    this.onFileStartUpload = this.onFileStartUpload.bind(this);
    this.onFileUploadSuccess = this.onFileUploadSuccess.bind(this);
    this.isAllUploadingFileFinished = this.isAllUploadingFileFinished.bind(this);
    this.changeAvatarSize = this.changeAvatarSize.bind(this);
    this.showAddTeacherModal = this.showAddTeacherModal.bind(this);
    this.hideAddTeacherModel = this.hideAddTeacherModel.bind(this);

    this.changeClass = this.changeClass.bind(this)
  }

  componentWillMount() {
    DataService.getAllStudents(this.props.params.classId).then(res => {
      let [students, removedStudents] = [[], []];
      res.forEach(item => {
        if (item.is_removed) {
          removedStudents.push(item);
        } else {
          students.push(item);
        }
      })
      this.setState({
        students: students,
        removedStudents: removedStudents
      })
    })
    DataService.getAllTeachers({class_id: this.props.params.classId}).then(res => {
      let classAdmin = 0;
      res.forEach(item => {
        if (item.is_admin) {
          classAdmin = item.id;
        }
      })
      this.setState({
        teachers: res,
        classAdmin: classAdmin,
        selectAdmin: classAdmin,
      })
    })
    DataService.getClassById(this.props.params.classId).then(res => {
      this.setState({
        classInfo: res
      })
    })
  }

  componentDidMount(){
    UserRoleStore.addChangeListener();
    CurrentRoleStore.addChangeListener();
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener();
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  _containerTitle(role, number) {
    let addState = false, setAdminState = false, currentRole = this.state.currentRole, roleStr;
    if (role == 'student') {
      addState = true;
      roleStr = '学生';
    } else {
      roleStr = '老师';
      if (currentRole.roleName == 'teacher') {
        if ((currentRole.associatName == 'school') || (currentRole.associatName == 'classGrade') || (currentRole.associatName == 'system')) {
          addState = true;
          setAdminState = true;
        } else if (currentRole.associatName == 'classRecord' && currentRole.associatObj.isClassAdmin) {
          addState = true;
          setAdminState = false;
        }
      }
    }

    return (
      <div className="container-title">
        <div className="title-text">{number}名{roleStr}</div>
        {addState ? <div className="button" onClick={this.showModal} data-type={role == 'teacher' ? 'addTeacher' : 'addStudent'}>
          <span className="icon-plus">+</span>
          添加{roleStr}
        </div> : ''}
        {setAdminState ? <div className="button" onClick={this.showModal} data-type="setAdmin">设置班主任</div> : ''}
        {role == 'teacher' && (currentRole.associatName == 'school' || currentRole.associatName == 'system') ? <Link className="import-students-btn" to={`school-admin/schools/${this.state.schoolId}/class-management/classes/${this.state.classId}/import-students`}>导入学生名单</Link> : ''}
      </div>
    )
  }

  _studentDetail(student, index) {
    let { currentRole } = this.state;
    return (
      <div className="student-detail-box detail-box" key={`student-${student.id}`}>
        <div>
          {student.avatar_url && <img className="avatar" src={student.avatar_url.match(/\?image/) ? student.avatar_url : student.avatar_url + '?imageView2/1/w/150'}/>}
          {!student.avatar_url && <div className="avatar default-avatar"></div>}
          <div className={"text" + (student.inner_code ? " code" : "")}>
            <div className="text-bg">{student.full_name}</div>
            {student.inner_code ? <div className="text-sm">班内编号:{student.inner_code}</div> : ''}
            <div className="text-sm">{(student.parents && student.parents.length) ? `已有${student.parents.length}位家长绑定` : '未绑定家长'}</div>
          </div>
          <div className="btn-group">
            <div onClick={this.showModal} data-type={(currentRole.associatName == 'school' || currentRole.associatName == 'system') ? "adjustStudent" :  "removeStudent"} data-index={index}>
              <span className="have-border">
                <div className="icon"></div>
                移出班级
              </span>
            </div>
            <div onClick={this.showModal} data-type="editStudent" data-index={index}>
              <div className="icon"></div>
              编辑资料
            </div>
          </div>
        </div>
      </div>
    )
  }

  _teacherDetail(teacher, index) {
    let currentRole = this.state.currentRole, showDelete = false;
    if ((currentRole.associatName == 'school') || (currentRole.associatName == 'system') || (currentRole.associatName == 'classGrade') || (currentRole.associatName == 'classRecord' && currentRole.associatObj.isClassAdmin)) {
      showDelete = true
    }
    let avatarStype = teacher.avatar_url ? {backgroundImage: `url(${teacher.avatar_url})`} : {};
    return (
      <div className="teacher-detail-box detail-box" key={`teacher-${teacher.id}`}>
        <div>
          <div className={teacher.avatar_url ? 'avatar' : 'avatar default-avatar'} style={avatarStype}></div>
          <div className="text">
            <div className="text-bg">
              {teacher.full_name}
              {teacher.id == this.state.classAdmin && <span className="admin">班主任</span>}
            </div>
            <div className="text-sm">{teacher.mobile_phone}</div>
          </div>
          {showDelete ? <div className="btn-group">
            <div onClick={this.showModal} data-type="removeTeacher" data-index={index}>
              <div className="icon"></div>
              移出班级
            </div>
          </div> : ''}
        </div>
      </div>
    )
  }

  showModal(e) {
    let [type, selectStudent, selectTeacher] = [e.currentTarget.dataset.type, null, null];

    if (type == 'removeStudent' || type == 'adjustStudent' ||  type == 'editStudent') {
      selectStudent = this.state.students[e.currentTarget.dataset.index];
    } else if (type == 'removeTeacher') {
      selectTeacher = this.state.teachers[e.currentTarget.dataset.index];

      if (selectTeacher.is_admin) {
        type = 'removeFail';
      }
    }
    if (type == 'addTeacher') {
      return this.showAddTeacherModal();
    }
    let { modal } = this.state;
    let [title, content, confirm, maskClosable] = ['', null, null, true];

    switch (type) {
      case 'removeStudent':
        title = <p className="modal-title">移出班级</p>;
        content = <p className="modal-text">确认要将{selectStudent.full_name}宝贝从班级中移出吗？</p>;
        confirm = <p className="confirm-no-bg" data-index={e.currentTarget.dataset.index} onClick={this.removeStudent}>确认移出</p>;
        break;

      case 'adjustStudent':
        title = <p className="modal-title">移出班级</p>;
        content = <p className="modal-text">
                    <p>(1).若此学生需要转入其他班级点击“学生转班”</p>
                    <p>(2).若此学生需要移出班级点击“移出班级”</p>
                  </p>;
        confirm = <div className="adjust-student-content">
                    <span data-index={e.currentTarget.dataset.index} onClick={this.adjustStudent}>学生转班</span>
                    <span data-index={e.currentTarget.dataset.index} onClick={this.removeStudent}>确认移出</span>
                  </div>;
        break;

      case 'removeFail':
        title = <p className="modal-title">移出失败</p>;
        content = <p className="modal-text">{selectTeacher.full_name}老师为班主任老师，请先去班主任设置移交班主任老师身份再删除此老师</p>;
        confirm = <p className="confirm-no-bg" onClick={this.hideModal}>我知道了</p>;
        break;

      case 'removeTeacher':
        title = <p className="modal-title">移出班级</p>;
        content = <p className="modal-text">确认要将{selectTeacher.full_name}老师从班级中移出吗？</p>;
        confirm = <p className="confirm-no-bg" data-index={e.currentTarget.dataset.index} onClick={this.removeTeacher}>确认移出</p>;
        break;

      case 'setAdmin':
        title = <p className="modal-title">设置班主任</p>;
        content = <div className="teacher-name-box">
          {this.state.teachers.map((teacher, index) => {
            return <div key={"set-admin-" + teacher.id} data-index={index} onClick={this.selectClassAdmin} className={teacher.id == this.state.selectAdmin ? "select-admin teacher-name" : "teacher-name"}>{teacher.full_name}</div>
          })}
        </div>;
        confirm = <div className="confirm" onClick={this.setClassAdmin}>设为班主任</div>;
        maskClosable = false;
        break;

      case 'addStudent':
        content = this._editStudent();
        confirm = <div className="confirm" onClick={this.editStudentApi}>确认添加</div>;
        maskClosable = false;
        break;

      case 'editStudent':
        content = this._editStudent(selectStudent, e.currentTarget.dataset.index);
        confirm = <div className="confirm" onClick={this.editStudentApi}>确认修改</div>;
        maskClosable = false;
        break;
    }

    modal.title = title;
    modal.content = content;
    modal.confirm = confirm;
    modal.visible = true;
    modal.type = type;
    modal.maskClosable = maskClosable;

    this.setState({
      modal: modal,
      selectStudent
    })
  }

  hideModal() {
    this.setState({
      modal: {
        visible: false,
        title: null,
        type: '',
        confirm: null,
        content: null,
      },
      changeClassModal: {
        visible: false,
        title: null,
        type: '',
        confirm: null,
        content: null,
      },
      editAvatar: false,
      selectClassId: undefined
    })
  }

  removeTeacher(e) {
    let [index, teachers] = [e.currentTarget.dataset.index, this.state.teachers];

    DataService.removeTeacher(teachers[index].id, this.props.params.classId).then(res => {
      if (!res.errors) {
        if (this.state.currentRole.roleId == teachers[index].id) {
          let roles = UserRoleStore.getState();
          let role = roles.find((role) => role.associatName == 'classRecord' && role.associatObj.id == this.state.classId);
          if (role) {
            UserRoleActions.deleteUserRole(role.key)
          }
        }

        teachers.splice(index, 1);
        this.setState({
          teachers: teachers
        })
        this.hideModal();
        message.success('该老师已被移出班级!');
      }
    })
  }

  addTeacher(teacher) {
    let teachers = this.state.teachers;

    if (teacher) {
      DataService.addTeacher(teacher.id, this.props.params.classId).then(res => {
        if (this.state.currentRole.roleId == teacher.id) {
          let roles = UserRoleStore.getState();
          let gradeAdmin = roles.find((role) => (role.associatName == 'classGrade' && role.associatObj.id == this.state.classInfo.class_grade_id));
          let schoolAdmin = roles.find((role) => (role.associatName == 'school' && role.associatObj.id == this.state.schoolId));
          let add_role = {
            id: this.state.currentRole.id,
            roleId: this.state.currentRole.roleId,
            roleName: 'teacher',
            fullName: this.state.currentRole.fullName,
            associatName: "classRecord",
            associatObj: {
              id: this.state.classInfo.id,
              className: this.state.classInfo.name,
              gradeId: this.state.classInfo.class_grade_id,
              gradename: this.state.classInfo.grade_name,
              schoolId: this.state.classInfo.school_id,
              schoolName: this.state.classInfo.school_name,
              isClassAdmin: false,
              isGradeAdmin: gradeAdmin ? true : false,
              isSchoolAdmin: schoolAdmin ? true : false,
            }
          }
          UserRoleActions.addUserRole(add_role)
        }
        teachers.push(teacher);

        this.setState({
          teachers: teachers,
          showAddTeacherModal: false
        })
        message.success('添加成功!');
      })
    }
  }

  showAddTeacherModal() {
    this.setState({
      showAddTeacherModal: true
    });
  }

  hideAddTeacherModel() {
    this.setState({
      showAddTeacherModal: false
    });
  }

  selectClassAdmin(e) {
    let [index, {teachers, modal}] = [e.currentTarget.dataset.index, this.state];
    let content = <div className="teacher-name-box">
        {teachers.map((teacher, i) => {
          return <div key={"set-admin-" + teacher.id} data-index={i} onClick={this.selectClassAdmin} className={teacher.id == teachers[index].id ? "select-admin teacher-name" : "teacher-name"}>{teacher.full_name}</div>
        })}
      </div>;
    modal.content = content;

    this.setState({
      selectAdmin: teachers[index].id,
      modal: modal
    })
  }

  setClassAdmin() {
    DataService.setClassAdmin(this.props.params.classId, this.state.selectAdmin).then(res => {
      let teachers = this.state.teachers;
      teachers.map(item => {
        if (item.id != this.state.selectAdmin) {
          item.is_admin = false;
        } else {
          item.is_admin = true;
        }
      })

      let role = UserRoleStore.getState().find((role) => role.associatName == 'classRecord' && role.associatObj.id == this.state.classId);
      if (role) {
        let associatObj = role.associatObj;
        if (this.state.selectAdmin == this.state.currentRole.roleId) {
          associatObj.isClassAdmin = true;
        } else {
          associatObj.isClassAdmin = false;
        }
        UserRoleActions.updateUserRole(role.key, {associatObj: associatObj})
      }

      this.setState({
        classAdmin: this.state.selectAdmin,
        teachers: teachers,
      })
      this.hideModal();
      message.success('班主任设置成功!');
    })
  }

  removeStudent(e) {
    let [index, {students, removedStudents}] = [e.currentTarget.dataset.index, this.state];

    DataService.removeStudent(students[index].id).then(res => {
      removedStudents.push(students[index]);
      students.splice(index, 1);
      this.setState({
        students: students,
        removedStudents: removedStudents
      })
      this.hideModal();
      message.success('该学生已被移出班级!');
    })
  }

  // 学生转班
  adjustStudent(e) {
    this.hideModal();

    let modal = {}
    DataService.getAllClassGrade(this.state.schoolId).then(res => {
      let grades = res.filter(g => !g.is_graduated)
      this.setState({
        grades,
      }, () => {
        modal.title = <p className="modal-title">加入班级</p>;
        let content = this._changeClass();
        let confirm = <div className="confirm" onClick={this.changeClass}>确认</div>;
        let maskClosable = false;

        modal.content = content;
        modal.confirm = confirm;
        modal.visible = true;
        modal.type = 'changeClass';
        modal.maskClosable = maskClosable;

        this.setState({
          changeClassModal: modal
        })
      })


    }, (response) => {
      message.info('获取班级失败');
    }).catch((error) => {
      message.info('获取班级失败');
    });
  }

  _changeClass() {
    let { grades, selectClassId } = this.state;
    return (

      <div className="modal-text">
        <div>选择需要移入的班级</div>
        <div className="grade-list-container">
          {grades.map(grade => <div className="grade-list" key={grade.id}>
                                <div className="grade_name">{grade.grade_name}</div>
                                  <div className="class-list">
              {grade.class_records.map(c => <div className={"class-name" + (selectClassId == c.id ? " selected" : '')} key={c.id} onClick={this.selectClass.bind(this, c)}>{c.name}</div>)}
                                  </div>
                                </div>)}
        </div>
      </div>
    )
  }

  selectClass(c) {
    let { changeClassModal} = this.state
    this.setState({
      selectClassId: c.id,
    }, () => {
      changeClassModal.content = this._changeClass();
      this.setState({
        changeClassModal
      })
    })
  }

  changeClass() {
    DataService.changeStudentClass(this.state.selectStudent.id, this.state.selectClassId).then(res => {
      if (this.state.classId != this.state.selectClassId) {
        let students = this.state.students.filter(s => s.id != this.state.selectStudent.id);
        this.setState({
          students
        })
      }
      message.success('转班成功');
      this.hideModal()
      this.setState({
        selectStudent: undefined
      })
    }, (response) => {
      message.info('转班失败');
    }).catch((error) => {
      message.info('转班失败');
    });

  }

  _editStudent(student, index, editAvatar = false) {
    let defaultValue = 1;
    if (!student) {
      student = {
        full_name: '',
        avatar_url: ''
      }
    } else {
      student = JSON.parse(JSON.stringify(student));
      student.index = index;
    }

    if (student.avatar_url && student.avatar_url.match('imageMogr2') && !student.avatar_url.avatarWidth) {
      let naturalUrl = student.avatar_url.replace(/\?imageMogr2(.+)$/, '');
      let matchInfo = student.avatar_url.match(/([0-9]+)x([0-9]+)a-?([0-9]+)a-?([0-9]+)/);
      student.naturalWidth = Number(matchInfo[1]) + Number(matchInfo[3] * 2);
      student.naturalHeight = Number(matchInfo[2]) + Number(matchInfo[4] * 2);
      student.avatarWidth = Number(matchInfo[1]);
      defaultValue = ((Math.min(student.naturalWidth, student.naturalHeight)) / matchInfo[1]).toFixed(1);
    }

    this.setState({
      editInfo: student
    })
    return (
      <div className="edit-student">
        <div className="edit-avatar">
          <div className="avatar-box">
            {student.avatar_url && <img className="avatar" src={student.avatar_url.match(/\?image/) ? student.avatar_url : student.avatar_url + '?imageView2/1/w/150'}/>}
            {!student.avatar_url && <div className="avatar no-avatar"></div>}
            {(!editAvatar && student.avatar_url) && <div className="edit-btn" onClick={this.editAvatar}>编辑头像</div>}
            {(!editAvatar && !student.avatar_url) &&
              <ReactQiniuModule
                className="edit-btn add-btn"
                onSuccess={this.onFileUploadSuccess}
                onStartPermit={this.onFileStartUpload}
                isAllFinish={this.isAllUploadingFileFinished}
                getUploadQuota={() => {return !this.state.uploading}}
                allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
                allowUploadFileSize={10} >
                <div>+添加照片</div>
              </ReactQiniuModule>
            }
          </div>
          {editAvatar &&
            <div className="edit-avatar-size">
              <div className="slider-box">
              -
              <Slider min={1} max={3} step={0.1} defaultValue={Number(defaultValue)} onChange={this.changeAvatarSize}/>
              +
            </div>
          </div>}
          {editAvatar &&
            <ReactQiniuModule
              className="choose-photo"
              onSuccess={this.onFileUploadSuccess}
              onStartPermit={this.onFileStartUpload}
              isAllFinish={this.isAllUploadingFileFinished}
              getUploadQuota={() => {return !this.state.uploading}}
              allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
              allowUploadFileSize={10} >
              <div>重选照片</div>
            </ReactQiniuModule>}
        </div>
        <div className="edit-name">
          <Input addonBefore={<span><span className="red">*</span>姓名</span>} defaultValue={student.full_name} onChange={this.editStudent} data-type="name"/>
        </div>
        <div className="edit-name">
          <Input addonBefore={<span>班内编号</span>} defaultValue={student.inner_code} onChange={this.editStudent} data-type="code" type="number"/>
        </div>
      </div>
    )
  }

  changeAvatarSize(value) {
    let editInfo = this.state.editInfo;
    let that = this;
    if (!this.state.getImgInfo && !editInfo.avatar_url.match('imageMogr2')) {
      editInfo.avatar_url = editInfo.avatar_url.replace(/\?imageView2(.+)$/, '');
      this.setState({
        getImgInfo: true,
      })
      $.ajax({
        url: `${editInfo.avatar_url}?imageInfo`,
        type:'GET',
        dataType:'json',
        success: function(data){
          let width = data.width < data.height ? data.width : data.height
          width = parseInt(width / value);
          editInfo.avatarWidth = width;
          editInfo.naturalWidth = data.width;
          editInfo.naturalHeight = data.height;
          editInfo.avatar_url = `${editInfo.avatar_url}?imageMogr2/crop/!${width}x${width}a${parseInt((data.width - width) / 2)}a${parseInt((data.height - width) / 2)}`;
          let modal = that.state.modal;
          modal.content = that._editStudent(editInfo, editInfo.index, true);

          that.setState({
            editInfo: editInfo,
            modal: modal,
            getImgInfo: false
          });
        },
        error: function(data){
          that.setState({
            getImgInfo: false
          })
        }
      })
    } else if (editInfo.naturalWidth) {
      editInfo.avatar_url = editInfo.avatar_url.replace(/\?imageMogr2(.+)$/, '');
      let width = parseInt(editInfo.naturalWidth / value)
      editInfo.avatarWidth = width;
      editInfo.avatar_url = `${editInfo.avatar_url}?imageMogr2/crop/!${width}x${width}a${parseInt((editInfo.naturalWidth - width) / 2)}a${parseInt((editInfo.naturalHeight - width) / 2)}`;
      let modal = that.state.modal;
      modal.content = that._editStudent(editInfo, editInfo.index, true);

      that.setState({
        editInfo: editInfo,
        modal: modal,
        getImgInfo: false
      });
    }
  }

  onFileUploadSuccess(newFileKey, fileName, size, remoteUrl) {
    let that = this;
    $.ajax({
      url: `${remoteUrl}?imageInfo`,
      type:'GET',
      dataType:'json',
      success: function(data){
        let width = data.width < data.height ? data.width : data.height
        let editInfo = that.state.editInfo;
        editInfo.avatarWidth = width;
        editInfo.naturalWidth = data.width;
        editInfo.naturalHeight = data.height;
        editInfo.avatar_url = `${remoteUrl}?imageMogr2/crop/!${width}x${width}a${parseInt((data.width - width) / 2)}a${parseInt((data.height - width) / 2)}`;
        let modal = that.state.modal;
        modal.content = that._editStudent(editInfo, editInfo.index, true);

        that.setState({
          editInfo: editInfo,
          uploading: false,
          modal: modal,
        });
      },
      error: function(data){
      }
    });
  }

  isAllUploadingFileFinished() {
    return !this.state.uploading;
  }

  onFileStartUpload(newFileKey) {
    this.setState({
      uploading: true
    })
    return true;
  }

  editAvatar() {
    let modal = this.state.modal;
    modal.content = this._editStudent(this.state.editInfo, this.state.editInfo.index, true);
    this.setState({
      modal: modal,
    })
  }

  editStudent(e) {
    let [type, editInfo] = [e.currentTarget.dataset.type, this.state.editInfo];
    if (type == 'name') {
      editInfo.full_name = e.target.value;
    }
    if (type == 'code') {
      editInfo.inner_code = e.target.value;
    }

    this.setState({
      editInfo: editInfo
    })
  }

  editStudentApi() {
    let {editInfo, students} = this.state;

    if (editInfo.full_name !== '') {
      if (editInfo.id) {
        DataService.updateStudent(editInfo.id, editInfo.avatar_url, editInfo.full_name, editInfo.inner_code).then(res => {
          students[editInfo.index].full_name = res.full_name;
          students[editInfo.index].avatar_url = res.avatar_url;
          students[editInfo.index].inner_code = res.inner_code;
          students.sort((a, b) => {
            if (a.inner_code && b.inner_code) {
              return a.inner_code - b.inner_code
            }
          })
          this.setState({
            students: students,
            editInfo: {
              full_name: '',
              avatar_url: '',
              inner_code: undefined
            },
          })
          this.hideModal();
          message.success('修改成功!');
        }, (error) => {
          if (error.errorMessage && error.errorMessage.errors[0].code == 53) {
            message.error('班内编号已存在!');
            return
          }
            message.error('修改失败!');
        });
      } else {
        editInfo.class_id = this.state.classId;
        DataService.createStudent(editInfo).then(res => {
          students.push(res);
          students.sort((a, b) => {
            if (a.inner_code && b.inner_code) {
              return a.inner_code - b.inner_code
            }
          })
          this.setState({
            students: students,
            editInfo: {
              full_name: '',
              avatar_url: '',
              inner_code: undefined
            },
          })
          this.hideModal();
          message.success('添加成功!');
        }, (error) => {
          if (error.errorMessage && error.errorMessage.errors[0].code == 53) {
            message.error('班内编号已存在!');
            return
          }
          message.error('添加失败!');
        });
      }
    }
  }

  render() {
    return (
      <div className="class-manage-page">
        <div className="teachers-container">
          {this._containerTitle('teacher', this.state.teachers.length)}
          <div className="teachers-details details">
            {this.state.teachers.map((teacher, index) => {
              return this._teacherDetail(teacher, index);
            })}
          </div>
        </div>
        <div className="students-container"></div>
          {this._containerTitle('student', this.state.students.length)}
          <div className="students-details details">
            {this.state.students.map((stu, index) => {
              return this._studentDetail(stu, index);
            })}
          </div>
          <Modal
            className="class-manage-page-modal"
            title={null}
            visible={this.state.modal.visible}
            footer={null}
            okText={this.state.modal.okText}
            onCancel={this.hideModal}
            maskClosable={this.state.modal.maskClosable}
          >
            {this.state.modal.title}
            {this.state.modal.content}
            {this.state.modal.confirm}
          </Modal>

          <Modal
            className="class-manage-page-modal"
            title={null}
            visible={this.state.changeClassModal.visible}
            footer={null}
            okText={this.state.changeClassModal.okText}
            onCancel={this.hideModal}
            maskClosable={this.state.changeClassModal.maskClosable}
          >
            {this.state.changeClassModal.title}
            {this.state.changeClassModal.content}
            {this.state.changeClassModal.confirm}
          </Modal>
          <AddTeacherModal title="添加老师" callBack={this.addTeacher} schoolId={this.state.schoolId} showModal={this.state.showAddTeacherModal} teachers={this.state.teachers} onHideTeacherModel={this.hideAddTeacherModel}/>
          {/* {showAdjustStudent ? this._adjustStudent() : ''} */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/SchoolAdminClassManagePage.jsx